export default {
  //If there is no internet connectivity, library returns BayunErrorInternetConnection
  //ERROR_INTERNET_CONNECTION: "BayunErrorInternetConnection",
  //If request has timed out, library returns BayunErrorRequestTimeOut
  //ERROR_REQUEST_TIMEOUT: "BayunErrorRequestTimeOut",
  //If Lockbox Management Server could not be reached, library returns BayunErrorCouldNotConnectToServer
  //ERROR_COULD_NOT_CONNECT_TO_SERVER: "BayunErrorCouldNotConnectToServer",
  //If decryption fails, library returns BayunErrorDecryptionFailed
  //ERROR_DECRYPTION_FAILED: "BayunErrorDecryptionFailed",
  //If text for encryption/decryption is null, library returns BayunErrorTextCannotBeNull
  //ERROR_TEXT_CANNOT_BE_NULL: "BayunErrorTextCannotBeNull",
  //If data for encryption/decryption is null, library returns BayunErrorDataCannotBeNull
  //ERROR_DATA_CANNOT_BE_NULL: "BayunErrorDataCannotBeNull",
  //If file for encryption/decryption is null, library returns BayunErrorFileCannotBeNull
  //ERROR_FILE_CANNOT_BE_NULL: "BayunErrorFileCannotBeNull",
  //If OrgName is null, library returns BayunErrorOrgNameCannotBeNull
  //ERROR_ORG_CANNOT_BE_NULL: "BayunErrorOrgNameCannotBeNull",
  //If OrgMemberId is null, library returns BayunErrorOrgMemberIdCannotBeNull
  //ERROR_ORG_MEMBER_ID_CANNOT_BE_NULL:
  //If no group type is specified when creating a new group, library returns BayunGroupTypeCannotBeNull
  //ERROR_GROUP_TYPE_CANNOT_BE_NULL: "BayunGroupTypeCannotBeNull",
  //If no json hashmap is specified, library returns BayunErrorNoInputJSON
  //ERROR_NO_INPUT_JSON: "BayunErrorNoInputJSON",
  // //If no key format hashmap is specified, library returns BayunErrorNoKeyFormatHashmap
  // ERROR_NO_KEY_FORMAT_HASHMAP: "BayunErrorNoKeyFormatHashmap",
  // //If the key in key format map is not found in input json map, library returns BayunErrorKeyNotFoundInJSON
  // ERROR_KEY_NOT_FOUND_IN_JSON: "BayunErrorKeyNotFoundInJSON",
  // // If the device has no screen lock enabled, library returns BayunErrorDevicePasscodeNotSet.
  // // Locked screen is required for SDK to work.
  //ERROR_DEVICE_PASSCODE_NOT_SET: "BayunErrorDevicePasscodeNotSet",
  // If device locked screen authentication is cancelled by the user, library throws BayunErrorDeviceAuthenticationRequired.
  //ERROR_DEVICE_AUTHENTICATION_REQUIRED:
  // "BayunErrorDeviceAuthenticationRequired",
  // If autoCreate is disabled and the entered member doesn't exist, SDK returns BayunErrorMemberDoesNotExistsInGivenOrg.
  //ERROR_MEMBER_NOT_EXISTS: "BayunErrorMemberDoesNotExistsInGivenOrg",
  // If autoCreate is disabled and the entered org doesn't exist, SDK returns BayunErrorOrgDoesNotExist.
  //ERROR_ORG_NOT_EXISTS: "BayunErrorOrgDoesNotExist",
  // If the SDK is unable to reproduce the userPrivateKey, from it's part, then SDK throws this error.
  // ERROR_COMBINING_PARTS: "BayunErrorCombiningParts",
  // If the user is trying to create a duplicate entry in DB, SDK throws BayunErrorDuplicateEntry
  //ERROR_DUPLICATE_ENTRY_CREATED: "BayunErrorDuplicateEntry",

  //If user access is denied(authentication token expires) or if user does not have right to perform
  //certain operation, library returns BayunErrorAccessDenied
  ERROR_ACCESS_DENIED: "BayunErrorAccessDenied",
  //If encryption fails, library returns BayunErrorEncryptionFailed
  ERROR_ENCRYPTION_FAILED: "BayunErrorEncryptionFailed",
  //If decryption fails, library returns BayunErrorDecryptionFailed
  ERROR_DECRYPTION_FAILED: "BayunErrorDecryptionFailed",
  ERROR_ENCRYPTED_DATA_NOT_FOUND: "BayunErrorEncryptedDataNotFound",
  ERROR_STORAGE_KEY_NOT_FOUND_IN_RESPONSE:
    "BayunErrorStorageKeyNotFoundInResponse",
  //If passphrase is invalid, library returns BayunErrorInvalidPassphrase
  ERROR_INVALID_PASSPHRASE: "BayunErrorInvalidPassphrase",
  //If passcode is invalid, library returns BayunErrorInvalidPasscode
  ERROR_INVALID_PASSCODE: "BayunErrorInvalidPasscode",
  //If passphrase for validation is null, library returns BayunErrorPassphraseCannotBeNull
  ERROR_PASSPHRASE_CANNOT_BE_NULL: "BayunErrorPassphraseCannotBeNull",
  //If credentials are invalid, library returns BayunErrorInvalidCredentials
  ERROR_INVALID_CREDENTIALS: "BayunErrorInvalidCredentials",
  // If credentials for authentication are null, library returns BayunErrorCredentialsCannotBeNull
  ERROR_CREDENTIALS_CANNOT_BE_NULL: "BayunErrorCredentialsCannotBeNull",
  //If member Status is Inactive, library returns BayunErrorUserInActive
  ERROR_USER_INACTIVE: "BayunErrorUserInActive",
  ERROR_MEMBER_NOT_APPROVED_YET: "BayunErrorMemberNotApprovedYet",
  //If app is not linked with Member Account, library returns BayunErrorAppNotLinked
  ERROR_APP_NOT_LINKED: "BayunErrorAppNotLinked",
  ERROR_MEMBER_APP_KEY_PAIR_ALREADY_EXISTS:
    "BayunErrorMemberAppKeyPairAlreadyExists",
  //If app id is invalid, library returns BayunErrorInvalidAppId
  ERROR_INVALID_APP_ID: "BayunErrorInvalidAppId",
  //If error is unknown, library returns BayunErrorSomethingWentWrong
  ERROR_SOMETHING_WENT_WRONG: "BayunErrorSomethingWentWrong",
  //If user authentication fails, library returns BayunErrorAuthenticationFailed
  ERROR_AUTHENTICATION_FAILED: "BayunErrorAuthenticationFailed",
  //If org name is invalid, library returns BayunErrorInvalidOrgName
  ERROR_INVALID_ORG_NAME: "BayunErrorInvalidOrgName",
  //If GroupId is null, library returns BayunErrorGroupIdCannotBeNull
  ERROR_GROUP_ID_CANNOT_BE_NULL: "BayunErrorGroupIdCannotBeNull",
  //If the member does not exists, library returns BayunErrorMemberDoesNotExist
  ERROR_MEMBER_DOESNT_EXIST: "BayunErrorMemberDoesNotExist",
  ERROR_MEMBERS_DOESNT_EXIST: "BayunErrorMembersDoesNotExist",
  //If groupId does not exists for GroupId, library returns BayunErrorGroupDoesNotExistsForGroupId
  ERROR_INVALID_GROUP_ID: "BayunErrorGroupDoesNotExistsForGroupId",
  //If member does not belong to Group, library returns BayunErrorMemberDoesNotBelongToGroup
  ERROR_MEMBER_DOESNT_BELONG_TO_GROUP: "BayunErrorMemberDoesNotBelongToGroup",
  //If participant  already exists in the Group, library returns BayunErrorParticipantAlreadyExistsInGroup
  ERROR_PARTICIPANT_EXISTS_IN_GROUP: "BayunErrorParticipantAlreadyExistsInGroup",
  //If participant tries to join private in the Group, library returns BayunErrorCannotJoinPrivateGroup
  ERROR_CANNOT_JOIN_PRIVATE_GROUP: "BayunErrorCannotJoinPrivateGroup",
  // If it's needed for the user to be authenticated again, library returns BayunErrorReauthenticationNeeded
  ERROR_REAUTHENTICATION_NEEDED: "BayunErrorReauthenticationNeeded",
  // If the session is alive but part-way through signing in, and the operation needs a settled
  // session, the SDK returns BayunErrorSessionNotReady. Distinct from
  // BayunErrorReauthenticationNeeded: the credential is good and the session survives, so the caller
  // should finish the flow it is in rather than send the user back to sign in.
  ERROR_SESSION_NOT_READY: "BayunErrorSessionNotReady",
  // If user answers less than Three security questions, library returns BayunErrorAtleastThreeAnswersRequired
  ERROR_AT_LEAST_THREE_ANSWERS_REQUIRED:
    "BayunErrorAtleastThreeAnswersRequired",
  // If user has provided wrong answers for more than Two out of Five security questions, library returns BayunErrorIncorrectAnswers
  ERROR_INCORRECT_ANSWERS: "BayunErrorIncorrectAnswers",
  // If the app secret provided is invalid, the SDK returns BayunErrorInvalidAppSecret.
  ERROR_INVALID_APP_SECRET: "BayunErrorInvalidAppSecret",
  // If the verification fails for any of the keys of the member, the SDK returns BayunErrorMemberVerificationFailed.
  ERROR_MEMBER_VERIFICATION_FAILED: "BayunErrorMemberVerificationFailed",
  // If the decryption fails for any component of the group, the SDK returns BayunErrorGroupDecryptionFailed
  ERROR_GROUP_DECRYPTION_FAILED: "BayunErrorGroupDecryptionFailed",
  // If the developer provides incomplete data for set security question, the SDK returns BayunErrorIncompleteSecurityQuestions
  ERROR_INCOMPLETE_SECURITY_QUESTIONS: "BayunErrorIncompleteSecurityQuestions",
  // If the developer tries to register a user that already exists, SDK returns BayunErrorUserAlreadyExists.
  ERROR_USER_ALREADY_EXISTS: "BayunErrorUserAlreadyExists",

  ERROR_MEMBER_ALREADY_EXISTS: "BayunErrorMemberAlreadyExists",

  ERROR_MEMBER_ALREADY_EXISTS_FOR_A_DIFFERENT_EMAIL_ADDRESS:
    "BayunErrorMemberAlreadyExistsForADifferentEmailAddress",
  // If the user being used to register a new member has passcode verification enabled, SDK returns "BayunErrorUserPasscodeVerificationEnabled"
  ERROR_USER_PASSCODE_VERIFICATION_ENABLED:
    "BayunErrorUserPasscodeVerificationEnabled",
  // If joing room does not exist
  ERROR_GROUP_DOES_NOT_EXIST: "BayunErrorGroupDoesNotExist",
  // If secret for FR model does not match
  ERROR_INCORRECT_SECRET: "BayunErrorIncorrectSecret",

  ERROR_LINK_USER_MEMBER_ON_ADMIN: "BayunErrorLinkUserMemberOnAdmin",

  ERROR_MEMBER_APP_NOT_REGISTERED: "BayunErrorMemberAppNotRegistered",

  ERROR_NULL_PASSCODE: "BayunErrorNullPasscode",

  ERROR_USER_IS_NOT_REGISTERED: "BayunErrorUserIsNotRegistered",

  ERROR_MEMBER_AUTHORIZATION_IS_PENDING:
    "BayunErrorMemberAuthorizationIsPending",

  ERROR_GROUP_KEY_SIGNATURE_FAILED: "BayunErrorGroupKeySignatureFailed",

  ERROR_GROUP_PRIVATE_KEY_SIGNATURE_FAILED:
    "BayunErrorGroupPrivateKeySignatureFailed",

  ERROR_NO_GROUP_PARTICIPANTS_IN_THE_PARAMETERS:
    "BayunErrorNoGroupParticipantsInTheParameters",

  ERROR_MEMBER_APP_NOT_APPROVED: "BayunErrorMemberAppNotApproved",

  ERROR_REGISTRATION_FAILED_APPLICATION_IS_NOT_APPROVED:
    "BayunErrorRegistrationFailedApplicationIsNotApproved",

  ERROR_INVALID_SERVER_PUBLIC_KEY: "BayunErrorInvalidServerPublicKey",

  ERROR_SERVER_VERIFICATION_FAILED: "BayunErrorServerVerificationFailed",

  ERROR_ORG_SETTINGS_ROLLED_BACK: "BayunErrorOrgSettingsRolledBack",

  ERROR_ORG_SETTINGS_SIGNATURE_INVALID:
    "BayunErrorOrgSettingsSignatureInvalid",

  ERROR_FACE_RECOGNITION_IS_DISABLED_FOR_THIS_DOMAIN:
    "BayunErrorFaceRecognitionIsDisabledForThisDomain",

  ERROR_CANNOT_SET_PARAMETER_REGISTER_FACE_ID_TO_TRUE_AS_ENABLE_FACE_RECOGNITION_IS_SET_TO_FALSE:
    "BayunErrorCannotSetParameterRegisterFaceIdToTrueAsEnableFaceRecognitionIsSetToFalse",

  ERROR_NOT_A_VALID_EMAIL: "BayunErrorNotAValidEmail",

  ERROR_MEMBER_CREATION_NOT_ALLOWED: "BayunErrorMemberCreationNotAllowed",

  ERROR_ORG_OR_MEMBER_OR_MEMBERAPP_ALREADY_EXIST:
    "BayunErrorOrgOrMemberOrMemberAppAlreadyExist",

  ERROR_USER_DOSE_NOT_EXISTS: "BayunErrorUserDoesNotExist",

  ERROR_DEVELOPER_KEY_VERIFICATION_FAILED:
    "BayunErrorDeveloperKeyVerificationFailed",

  ERROR_USER_SIGNING_KEY_DECRYPTION_FAILED: "User signing private key decryption failed",

  ERROR_MEMBER_NOT_AUTHORIZED_TO_CREATE_GROUPS:
    "BayunErrorMemberNotAuthorizedToCreateGroups",

  ERROR_TOKEN_NOT_FOUND: "BayunErrorTokenNotFound",

  INVALID_ORG_OR_MEMBER_NAME: "BayunErrorInvalidOrgOrMemberName",

  APP_NOT_EXIST_FOR_ORG: "BayunErrorAppNotExistForOrg",

  RE_REGISTER: "BayunErrorReRegister",

  USER_REGISTRATION_PENDING: "BayunErrorUserRegistrationPending",

  APP_DOES_NOT_HAVE_THE_CORRECT_ROLE: "BayunErrorAppDoesNotHaveTheCorrectRole",

  INVALID_KEY_PAIR_ID: "BayunErrorInvalidKeyPairId",

  AUTO_APPROVED_MEMBER_ACCESS_DENIED:
    "BayunErrorAutoApprovedMemberAccessDenied",

  AUTO_APPROVED_MEMBER_CANNOT_ADD_TO_GROUP:
    "BayunErrorAutoApprovedMemberCannotAddToGroup",

  CANNOT_ADD_MEMBER_FROM_OTHER_ORG: "BayunErrorCannotAddMemberFromOtherOrg",

  ERROR_ORG_VALIDATION_POLICY_DOES_NOT_ALLOW_THIS_OPERATION:
    "BayunErrorOrgValidationPolicyDoesNotAllowThisOperation",

  CANNOT_ADD_AUTO_APPROVED_MEMBER_TO_GROUP:
    "BayunErrorCannotAddAutoApprovedMemberToGroup",

  ERROR_ORGANIZATION_ALREADY_EXISTS: "BayunErrorOrganizationAlreadyExists",

  ERROR_REGISTRATION_INCOMPLETE: "BayunErrorRegistrationIncomplete",

  ERROR_USER_HAVE_NO_ACTIVE_MEMBERS: "BayunErrorUserHaveNoActiveMembers",

  ERROR_USER_RECOVERY_ALREADY_IN_PROGRESS:
    "BayunErrorUserRecoveryAlreadyInProgress",

  ERROR_USER_HAS_DEVELOPER_ACCOUNT_DURING_RECOVERY:
    "BayunErrorUserHasDeveloperAccountDuringRecovery",

  ERROR_CANNOT_LINK_DEVELOPER_ACCOUNT_DURING_RECOVERY:
    "BayunErrorCannotLinkDeveloperAccountDuringRecovery",

  ERROR_ACCOUNT_IN_RECOVERY_MODE: "BayunErrorAccountInRecoveryMode",

  ERROR_INVALID_K_N_VALUES: "BayunErrorInvalidKNValues",

  ERROR_INVALID_KEY_PAIR: "BayunErrorInvalidAppKeyPair",

  ERROR_MEMBER_APP_NOT_EXIST_FOR_ID: "BayunErrorMemberAppNotExistForId",

  ERROR_MEMBER_PUBLIC_KEY_NOT_EXISTS: "BayunErrorMemberPublicKeyDoesNotExist",

  ERROR_USER_NOT_ASSOCIATED_WITH_MEMBER:
    "BayunErrorUserNotAssociatedWithMember",

  ERROR_MEMBER_LOCK_BOX_NOT_FOUND_FOR_MEMBER:
    "BayunErrorMemberLockBoxNotFoundForMember",

  ERROR_MEMBER_CREATION_APP_KEY_PAIR_ID_REQUIRED:
    "BayunErrorMemberCreationAppKeyPairIdRequired",

  ERROR_ACCESS_APP_KEY_PAIR_ID_REQUIRED:
    "BayunErrorAccessAppKeyPairIdRequired",
};
